module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAOCAYAAAAmL5yKAAABCUlEQVQokY3SvyuFcRTH8dd9PImBQVkZLBZFMdhYbG75AxQ2iyzqGiSbTLdMyo/ubr9KyOIPsCg/hlsGsijqpiTD/apvj4f7nDp9zznf83l3Op1SdXdPAdtCGWPZj6SAeAYb6MjTtgOUcYxSVEtRwQsG0hzRMGYxh8mc/0PM4x5JihHs4xSXqOeMG9sFnrCJZooDTOBEa0n/ieEoThKMhvgNPW3EsIKH4FcJziJAbwFAVxR3JlhADXcFJ9jBUPDxBM8Bcp4B1LSWmrXFAOnm9x3EgFVMoZrpmcYarjH4F+AdryGuoBH1LGEdfXkT/CzxMap9YBm3If/ENvrRyF5iM7w3mXo9eGxf8A09IS/H9oBXewAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/extension_icon.png
// module id = EZv/
// module chunks = 1